import React from 'react';
import styled from 'styled-components';
import * as styles from './styles';
import { HowItWorksProps } from './models';
import { useTranslation } from '@sunbit-dev/translations';
import { getTermByVerticalType } from '~/utils/getTermByVerticalType';
import { useSelector } from 'react-redux';
import * as purchaseStore from '~/store/reducers/purchase/purchase';
import validatePaperIcon from '../../../../../../../../assets/validate-paper.svg';
import applicationIcon from '../../../../../../../../assets/application.svg';
import thumbsUpIcon from '../../../../../../../../assets/thumbs-up.svg';

const stepIcons = [validatePaperIcon, applicationIcon, thumbsUpIcon];

export const HowItWorks = styled(({ className }: HowItWorksProps) => {
  const { t } = useTranslation('landing_page', { keyPrefix: 'welcome_view.how_it_works' });
  const { purchaseInfo } = useSelector(purchaseStore.getStore);
  const careTerm = getTermByVerticalType('careTerm', purchaseInfo?.isHealthcareVertical);

  const steps = [t('step_1'), t('step_2'), t('step_3', { careTerm })];

  return (
    <div className={className}>
      <div className="text-section">
        <p className="title">{t('title')}</p>
        <p className="subtitle">{t('subtitle') + (purchaseInfo.amountRequested && purchaseInfo.roNumber ? '*' : '')}</p>
      </div>
      {steps.map((step, index) => (
        <div key={index} className="step">
          <img className="step-icon" src={stepIcons[index]} alt={`step-${index + 1}-icon`} />
          {step}
        </div>
      ))}
    </div>
  );
})`
  ${styles.HowItWorks}
`;
